var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAi = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__d",
    d: "M0 0L38.61 0 38.61 39.424 0 39.424z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__f",
    d: "M0.042 0.175L27.336 0.175 27.336 9.318 0.042 9.318z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__b",
    width: "178.6%",
    height: "178.6%",
    x: "-39.3%",
    y: "-31%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3.645,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 3.645,
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.588235294 0 0 0 0 0.588235294 0 0 0 0 0.588235294 0 0 0 0.541220498 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__a",
    cx: 18,
    cy: 18,
    r: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(10 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__b)",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFF",
    strokeWidth: 7.29,
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.537 33.03c-.19.212-.385.42-.585.622-.22.226-.448.447-.68.663-3.43 3.173-7.976 5.11-12.967 5.11-4.991 0-9.538-1.937-12.968-5.11-.231-.216-.46-.437-.68-.663-.199-.202-.394-.41-.584-.621C1.923 29.525 0 24.847 0 19.712 0 8.826 8.643 0 19.305 0 29.967 0 38.61 8.826 38.61 19.712c0 5.135-1.923 9.813-5.073 13.318z",
    mask: "url(#prefix__e)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF0F7",
    d: "M27.9 30.32c-.222.221-.456.44-.692.652-7.522 6.704-18.99 6.704-26.512 0-.237-.208-.47-.427-.696-.653.824-.497 1.73-.848 2.677-1.037l6.458-1.308.718-.145 2.795-.568.23-.046L13.953 27l1.216.247h.079l2.788.564.717.148 6.459 1.309c.951.192 1.861.548 2.687 1.051z",
    transform: "translate(6.3 .9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E7EF",
    d: "M9 22.5v5.659c0 2.343 2.218 4.24 4.954 4.24 1.285.011 2.53-.43 3.5-1.242.907-.753 1.433-1.845 1.446-2.998V22.5H9z",
    transform: "translate(6.3 .9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEFF7",
    d: "M22.47 13.298C18.955 4.757 16.098 4.5 13.5 4.5c-2.596 0-5.85.759-8.966 8.798l-.021.513c-.142 3.22.888 6.38 2.89 8.863l1.825 2.266c1.057 1.31 2.63 2.065 4.287 2.06 1.65 0 3.216-.755 4.269-2.06l1.807-2.266c2-2.48 3.033-5.635 2.897-8.852l-.018-.524z",
    transform: "translate(6.3 .9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD3E2",
    d: "M22.575 4.892c.033-.162.05-.327.051-.493C22.626 1.97 19.814 0 16.35 0c-1.58-.027-3.13.422-4.437 1.287-.576-.086-1.158-.126-1.741-.121-1.754-.031-3.402.813-4.371 2.238-1.39 1.117-2.197 2.78-2.2 4.537v6.464l.594.894c.367 0 .935-.48 1.1-.822l1.742-5.006h.788c1.383-.023 2.75-.294 4.033-.8 3.993 1.319 8.434.543 8.434.543l1.477 5.23c.143.358-.07.716.327.716l1.305-.762V7.867c0-1.045-.284-2.072-.825-2.975z",
    transform: "translate(6.3 .9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF0F7",
    d: "M5.398 15.753c.03-.568-.284-1.093-.782-1.302-.082-.033-.169-.05-.257-.051-.695 0-.759 1.211-.759 2.307 0 1.097.769 2.193 1.455 2.193.089 0 .177-.02.257-.06l.086-3.087zM21.602 15.753c-.029-.571.29-1.097.788-1.302.082-.033.169-.05.256-.051.678 0 .754 1.211.754 2.307 0 1.097-.763 2.193-1.442 2.193-.09 0-.177-.02-.258-.06l-.098-3.087z",
    transform: "translate(6.3 .9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.616 30.106)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ai.4a199278.svg";
export { ForwardRef as ReactComponent };